import getOr from "lodash/fp/getOr";
import { setStep } from "../../components/walkthrough";
import { GLOBAL_CONSTANTS } from "../../global/constants";
import { ROOT_GLOBAL } from "../../global/root";
import { validCountries } from "../../global/validCountries";
import { Auth } from "../../models/auth";
import { TariffField } from "../../models/tariffField";
import { aiclassify, classification, getHsVersion, imageSearch, tariffFields } from "../../utils/api";
import { additionCodedata } from "../../utils/euro";
import { getCurrentUser } from "../../utils/firebase";
import { stripHTML } from "../../utils/input";
import { ELEMENT_TYPE, getCountryDetail, getParamUrl, historyPushState, isOverflowing, Track, validate } from "../../utils/utils";
import { checkSearchForm } from "../../utils/validate";
// import { getMap } from "./geoMap";
import { setOrderInfoLabel } from "./orderinfo";
import { getTariff, setUpTariffEvent } from "./tariff";
// import { getExportRequirement, getImportRequirement, getMarketRank, getPotential, getStatictic, loadColor } from "./tradeAdvisory";
import { getExportRequirement, getImportRequirement, loadColor } from "./tradeAdvisory";
import { loadClassification, setUpClassifications } from "./classification";
import { changeQueryString } from "../../utils/url";
import Env from "../../environments";
// eslint-disable-next-line no-unused-vars
import { AIClassification, Question } from "../../models/AIClassification";
// eslint-disable-next-line no-unused-vars
import { Classification } from "../../models/classification";

const queryString = require('query-string');
const $ = window.jQuery;

const TAB_ID = {
  COMMODITY: "commodity",
  BROWSE: "browse"
}
let isActiveTab = TAB_ID.COMMODITY;
let cntRetry = 0;

export const initEventSearchBar = ({ disableAutoComplete = false } = {}) => {
  setUpCountrySelect();
  if (!disableAutoComplete) {
    autoCompleteHsCode();
  }
  setUpSearchImage();
  setUpOrderInfo();
  setUplimitation();
  setUpShare();
  setUpSendToEmail();
  setUpTariff();
  setUpClassifications();

  $(".go-button .btn").on("click", function (e) {
    e.preventDefault();
    $('#order-info').modal('hide');
    if ($('.walkthrough.open').length > 0) {
      setStep(4);
    } else {
      search(false, true);
    }
  });

  $('body').on('click', '.section-overview img.edit', function (e) {
    changeSearchInput($(this).attr("data-target"));
  });

  $('body').on('click', '.section-overview.header h2 .title', function (e) {
    let tab = $(this).closest("h2").attr("tab");
    setActiveTab(tab);
  });

  $('.product input.form-control').on('keyup', function (e) {
    window.searchData.product = $(this).val();
    checkSearchForm();
    const keycode = (e.keyCode ? e.keyCode : e.which);
    if (keycode === 13 && window.searchData.destination && (window.searchData.product || window.searchData.image)) {
      const list = $('.section-search .product .clearable .autocomplete-box .result-list li');
      list.each((index, element) => {
        if ($(element).attr("data-hs") === window.searchData.product) {
          window.searchData.hs = window.searchData.product;
        }
      });
      $('.section-search .product .clearable .autocomplete-box').hide();
      search(true, true);
    }
  })

  keepQuerySetup();
}

export const keepQuerySetup = () => {
  $('.section-overview .hs-box a[keep-query], .section-menu.menu-navigation .menu-body a[keep-query], .mobile-menu a[keep-query], .section-header .menu-header a[keep-query]').each(function (i, obj) {
    $(this).attr("href", `${$(this).attr('href').split("?")[0]}${window.location.search}`);
  });
}

export const initDataSearchBar = (reset = false) => {
  let urlParam = getParamUrl();
  for (const [key, value] of Object.entries(urlParam)) {
    urlParam[key] = decodeURIComponent(value);
  }

  window.searchData = urlParam;
  window.searchData.destination = getCountryDetail(window.searchData.destination).iso2

  // Check translate for NO
  if (window.searchData.destination === "NO") {
    $(".section-overview .country .custom-fields").removeClass("translate").addClass("translate");
    $(".search-form .order-info").removeClass("translate").addClass("translate");
  } else {
    $(".section-overview .country .custom-fields").removeClass("translate");
    $(".search-form .order-info").removeClass("translate");
  }

  window.searchData.export = getCountryDetail(window.searchData.export).iso2
  $('.export-country select')[0].selectize.setValue(window.searchData.export, true);
  $('#order-info .origin-country select')[0].selectize.setValue(window.searchData.export, true);
  $('.destination-country select')[0].selectize.setValue(window.searchData.destination, true);
  $('.product input.form-control').val(window.searchData.hs || window.searchData.product);
  if (reset) {
    resetData();
    // if (!window.searchData.hs) {
    if (!window.searchData.hs && !window.searchData.product) {
      $(".product input.form-control").val(window.searchData.hs).trigger("change");
      window.searchData.hs = '';
      setUom();
    }
  }
  checkSearchForm();
  // if (window.searchData.destination && window.searchData.hs) {
  if (window.searchData.destination) {
    getDataWithHS(window.searchData);
  }
}

export const setUpSendToEmail = () => {
  $('#sendtoemail').on('hidden.bs.modal', function (e) {
    $(".sendMeEmail-form .message").hide();
    $(".sendMeEmail-form input").removeClass("is-invalid");
  });

  $('#sendtoemail').on('shown.bs.modal', function (e) {
    $(".sendMeEmail-form .message").hide();
    $(".sendMeEmail-form input").removeClass("is-invalid");
    const user = getCurrentUser();
    if (user) {
      const displayName = user.displayName;
      const email = user.email;
      if (!$('#sendtoemail .name input').val()) {
        $('#sendtoemail .name input').val(displayName).trigger("change");
      }
      if (!$('#sendtoemail .email input').val()) {
        $('#sendtoemail .email input').val(email).trigger("change");
      }
    }
    $(".sendMeEmail-form .name input").focus();
  });
}

export const setUpShare = () => {
  $('.report .share-group img').on("click", function (e) {
    let fakeLink;
    switch (this.className) {
      case "facebook":
        fakeLink = $(`<a href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}" target="_blank"/>`);
        fakeLink.appendTo("body")[0].click();
        fakeLink.remove();
        break;
      case "linkedin":
        fakeLink = $(`<a href="https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}" target="_blank"/>`);
        fakeLink.appendTo("body")[0].click();
        fakeLink.remove();
        break;
      case "whatapp":
        fakeLink = $(`<a href="https://wa.me/?text=${encodeURIComponent(window.location.href)}" data-action="share/whatsapp/share" target="_blank"/>`);
        fakeLink.appendTo("body")[0].click();
        fakeLink.remove();
        break;
      case "telegram":
        fakeLink = $(`<a href="https://telegram.me/share/url?url=${encodeURIComponent(window.location.href)}" target="_blank"/>`);
        fakeLink.appendTo("body")[0].click();
        fakeLink.remove();
        break;
      case "twitter":
        fakeLink = $(`<a href="https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}" target="_blank"/>`);
        fakeLink.appendTo("body")[0].click();
        fakeLink.remove();
        break;
      default:
        break;
    }
  })

  $('.report .button-group .btn').on("click", function (e) {
    if (navigator.share) {
      navigator.share({
        url: window.location.href
      }).then(() => {
        console.log('Thanks for sharing!');
      }).catch(console.error);
    } else {
      $('.report .share-group').show();
      $('.report .button-group .btn').hide();
    }
  });
}

export const setUplimitation = () => {
  $('.section-limit .upgrade-box button.upgrade').on('click', function () {
    window.location.href = ROOT_GLOBAL.YOUR_PLAN + '?cb=' + encodeURIComponent(window.location.href);
  });

  $('.section-limit .upgrade-box button.signup').on('click', function () {
    window.location.href = Auth.callBackSignUp(`${ROOT_GLOBAL.USER_TRADE_ADVISORY}${window.location.search}`);
  });

  $('#popup-limit .signup').on('click', function () {
    window.location.href = Auth.callBackSignUp(`${ROOT_GLOBAL.USER_TRADE_ADVISORY}${window.location.search}`);
  });

  $('#popup-limit .login').on('click', function () {
    window.location.href = Auth.callBackLogin(`${ROOT_GLOBAL.USER_TRADE_ADVISORY}${window.location.search}`);
  });
}

export const setUpOrderInfo = () => {
  $('.search-form .order-info').css("display", "none");
  $('.search-form .order-info .order-info-label').on('click', function (e) {
    setStep(4);
    $('#order-info').modal('show');
    $('#order-info .input-list .form-group:first .input-box .input input').focus();
    $('#order-info .input-list .form-group:first .input-box .input select').focus();
  });
  $('#order-info').on('hidden.bs.modal', function (e) {
    $(".order-info .order-info-label").removeClass('active');
    window.isEdit = false;
  });

  $('#order-info').on('shown.bs.modal', function (e) {
    $(".order-info .order-info-label").addClass('active');
  });

  $('#order-info .box.order-info .tariff-field-error button').on('click', function (e) {
    $('#order-info .box.order-info').removeClass('not-found').addClass('report-done');
    setTimeout(() => {
      $('#order-info').modal('hide');
      $('#order-info .box.order-info').removeClass('report-done');
    }, 1500)
    resetHS();
  });
}

export const setUpSearchImage = () => {
  $('.section-search .product .clearable img').on("click", function (e) {
    clearSearchImage(false);
    $('.section-search .product .clearable .search-image').toggle();
  });

  $("body").mouseup(function (e) {
    let container = $(".section-search .product .clearable .search-image");
    if (!container.is(e.target) && container.has(e.target).length === 0 && !$('.section-search .product .clearable img').is(e.target)) {
      clearSearchImage();
    }
  });

  $('.section-search .product .clearable .search-image .search-image-box button').on("click", function (e) {
    $('.section-search .product .clearable .search-image .search-image-box input').trigger("click");
  });

  $('.section-search .product .clearable .search-image .search-image-box input').change(function () {
    const filesize = getOr(undefined, "files[0].size")(this) / 1024 / 1024;
    if (filesize !== undefined && filesize > 5) {
      $('.section-search .product .clearable .search-image .search-image-box .error').text("Please upload smaller image.");
    } else {
      const apiTime = Date.now();
      window.apiTime = apiTime;
      $('.section-search .product .clearable .search-image .search-image-box .loading-box').css("display", "flex");
      const exportCountry = $(".export-country select").val();
      const destination = $(".destination-country select").val();
      imageSearch(exportCountry, destination, this.files[0], function (data) {
        if (data.length) {
          $('.search-form .product input').val('');
          window.searchData.hs = '';
          delete window.orderInfo;
          setOrderInfoLabel();
          $('.section-search .product .clearable .search-image .search-image-box').hide();
          $('.section-search .product .clearable .search-image .search-image-box .loading-box').hide();
          $('.section-search .product .clearable .search-image').hide();
          let html = ""
          data.forEach(item => {
            html += `<li data-hs="${item.code}" ${item.uom ? 'data-uom="' + item.uom + '"' : ''} data-text="${item.label}" class="ui-menu-item"><div class="autocomplete-item"><div class="hs">${item.code}</div><div class="desc">${item.fullDescription}</div></div></li>`;
          })
          fillAutocomplete(html);
        } else {
          $('.section-search .product .clearable .search-image .search-image-box .loading-box').hide();
          $('.section-search .product .clearable .search-image .search-image-box .error').text("NO RESULTS FOUND.");
        }
      }, function (error) {
        $('.section-search .product .clearable .search-image .search-image-box .loading-box').hide();
        $('.section-search .product .clearable .search-image .search-image-box .error').text(GLOBAL_CONSTANTS.DEFAULT_ERROR);
      }, apiTime);
      $('.section-search .product .clearable .search-image .search-image-box input').val('');
    }
  });

  $('.product input.form-control').on('click', function (e) {
    clearSearchImage();
  });
}

export const setUpCountrySelect = () => {
  validCountries.data.forEach(element => {
    const countryOption = new Option(element.name, element.iso2, false, false);
    $(countryOption).attr("data-extra-search", JSON.stringify(element));
    $('.export-country select').append(countryOption);
  });

  let descriptionCountry = (Env.DUTY_CAST_DESTINATION_COUNTRY || "US").split(",");

  descriptionCountry.forEach(item => {
    let element = validCountries.data.find(i => i.iso2 === item);
    if (element) {
      const countryOption2 = new Option(element.name, element.iso2, false, false);
      $(countryOption2).attr("data-extra-search", JSON.stringify(element));
      $('.destination-country select').append(countryOption2);
    }
  });

  $('.export-country select').selectize({
    placeholder: "Select country",
    dataAttr: 'data-extra-search',
    searchField: ['value', 'text', 'iso2', 'iso3', 'data-value'],
    onDropdownOpen: function () {
      this.latest = this.getValue() || this.latest;
      this.$input.get(0).selectize.clear(true);
      setStep(3)
    },
    onBlur: function () {
      if (this.getValue() === '') {
        this.setValue(this.latest);
      }
    },
    onChange: function (value) {
      if (value && value !== this.latest) {
        validate('.export-country select', undefined, true);
        if (window.searchData) {
          window.searchData.export = value;
        }
        $('#order-info .origin-country select')[0].selectize.setValue(value, true);
        checkSearchForm();
        // if (window.isDetail) {
        //   search(false);
        // } else {
        //   fetchCustomField(false);
        // }
      }
      // if (!validate(".destination-country select", undefined, false, false)) {
      //   $('.destination-country select')[0].selectize.open();
      // }
    }
  });

  $('.destination-country select').selectize({
    placeholder: "Select country",
    dataAttr: 'data-extra-search',
    searchField: ['value', 'text', 'iso2', 'iso3', 'data-value'],
    onDropdownOpen: function () {
      this.latest = this.getValue() || this.latest;
      this.$input.get(0).selectize.clear(true);
      setStep(1)
    },
    onBlur: function () {
      if (this.getValue() === '') {
        this.setValue(this.latest);
      }
    },
    onChange: function (value) {
      if (value && value !== this.latest) {
        validate('.destination-country select', undefined, true);
        if (window.searchData) {
          window.searchData.destination = value;
        }
        resetSearch();

        // Check translate for NO
        if (value === "NO") {
          $(".section-overview .country .custom-fields").removeClass("translate").addClass("translate");
          $(".search-form .order-info").removeClass("translate").addClass("translate");
        } else {
          $(".section-overview .country .custom-fields").removeClass("translate");
          $(".search-form .order-info").removeClass("translate");
        }

        checkSearchForm();
        if (window.isDetail) {
          search(false);
        } else {
          // fetchCustomField(false);
        }
      }
      if (!validate(".product input.form-control", undefined, false, false, window.$(".product input.form-control").attr("data") || "")) {
        $('.product input').focus();
      }
    }
  });
}

export function changeSearchInput(selector) {
  if (selector.indexOf("#order-info") !== -1) {
    $('.search-form .order-info .order-info-label').trigger('click');
  }
  if ($(selector).prop("tagName") === "SELECT") {
    $(selector).first().focus();
    $(selector)[0].selectize.open();
  } else {
    $(selector).first().focus();
  }
}

function clearSearchImage($toggle = true) {
  if ($toggle) {
    $('.section-search .product .clearable .search-image').hide();
  }
  $('.section-search .product .clearable .search-image .search-image-box').show();
  $('.section-search .product .clearable .search-image .search-image-box .error').text("");
  $('.section-search .product .clearable .search-image .search-image-box input').val('');
}

export function fillAutocomplete(html = "") {
  if (html) {
    const query = {
      destination: window.searchData.destination,
      product: $('.product input.form-control').val()
    };
    let url = queryString.stringify(query);
    url = url ? `/classification?${url}` : "/classification";
    $('.section-search .product .clearable .autocomplete-box .classification-box a').attr("href", url);
    $('.section-search .product .clearable .autocomplete-box').show();
    $('.section-search .product .clearable .autocomplete-box .result-list .ui-autocomplete').html(html);
    if (!$('.section-search .product input.form-control').is(":focus")) {
      $('.section-search .product input.form-control').focus();
    }
  } else {
    $('.section-search .product .clearable .autocomplete-box .result-list .ui-autocomplete').scrollTop(0);
    $('.section-search .product .clearable .autocomplete-box').hide();
    $('.section-search .product .clearable .autocomplete-box .result-list .ui-autocomplete').html("");
  }
}

export function setUom(data = "") {
  window.searchData.uom = data;
  setOrderInfoLabel()
}

export function resetSearch() {
  window.searchData = {
    destination: window.searchData.destination,
    export: '',
    hs: '',
    uom: ''
  }
  $('.product input.form-control').val('');
  $('.export-country select')[0].selectize.clear(true);
  $(".main-body > .section").css('display', '');
  $(".main-body > .section.section-goods").css('display', 'none');
  delete window.orderInfo;
  setUom("");
}

export function resetHS() {
  window.searchData = {
    destination: window.searchData.destination,
    export: window.searchData.export,
    hs: '',
    uom: ''
  }
  $('.product input.form-control').val('');
  delete window.orderInfo;
  setUom("");
}

export function isChangeSearchParam() {
  const exportCountry = window.searchData.export;
  const destination = window.searchData.destination;
  const hs = window.searchData.hs;
  const newExportCountry = getParamUrl("export");
  const newDestination = getParamUrl("destination");
  const newHs = getParamUrl("hs");
  if (exportCountry !== newExportCountry || destination !== newDestination || hs !== newHs) {
    return true;
  }
  for (let i = 0; i < window.orderInfo?.length; i++) {
    const element = window.orderInfo[i];
    if (element.type === 'europaAdditionalAgricultural') {
      for (let j = 0; j < additionCodedata.fields.length; j++) {
        if (window.searchData[additionCodedata.fields[j].name] + '' !== getParamUrl(additionCodedata.fields[j].name) + '') {
          return true;
        }
      }
    } else if (window.searchData[element.name] + '' !== getParamUrl(element.name) + '' || window.searchData.currency !== getParamUrl('currency')) {
      return true;
    }
  }
  return false;
}

function autoCompleteapi() {
  // const exportCountry = $(".export-country select").val();
  const destination = $(".destination-country select").val();
  const term = $('.product input.form-control').val();
  const apiTime = Date.now();
  window.apiTime = apiTime;
  // hsSearch(exportCountry, destination, term, function (data) {
  classification(destination, term, undefined, undefined, function (data) {
    let html = "";
    data.forEach(item => {
      html += `<li data-hs="${item.hsCode}" ${item.uom ? 'data-uom="' + item.uom + '"' : ''} data-text="${item.hsCode + " - " + (item.description || item.fullDescription)}" class="ui-menu-item"><div class="autocomplete-item"><div class="hs">${item.hsCode}</div><div class="desc">${item.fullDescription}</div></div></li>`;
    })
    fillAutocomplete(html);
  }, function (error) {
    console.error(error);
  }, apiTime);
}

export const autoCompleteDropdownKeyUp = (e) => {
  if (e.which === 38 && $('.section-search .product .clearable .autocomplete-box').css("display") !== "none") {
    const list = $('.section-search .product .clearable .autocomplete-box .result-list li');
    const currentIndex = $('.section-search .product .clearable .autocomplete-box .result-list li.active').index();
    const next = $(list.get((currentIndex - 1) % list.length));
    list.removeClass("active");
    next.addClass("active");
    const topPosition = next.position().top;
    if (topPosition < 0) {
      list.parent().scrollTop(list.parent().scrollTop() + topPosition - 8);
    }
    return;
  }

  if (e.which === 40 && $('.section-search .product .clearable .autocomplete-box').css("display") !== "none") {
    const list = $('.section-search .product .clearable .autocomplete-box .result-list li');
    const currentIndex = $('.section-search .product .clearable .autocomplete-box .result-list li.active').index();
    const next = $(list.get((currentIndex + 1) % list.length));
    list.removeClass("active");
    next.addClass("active");
    const topPosition = next.position().top;
    const height = next.height();
    const distance = topPosition + height - 300;
    if (distance > 0) {
      list.parent().scrollTop(list.parent().scrollTop() + distance + 8);
    }
    return;
  }

  if (e.which === 13 && $('.section-search .product .clearable .autocomplete-box').css("display") !== "none") {
    $('.section-search .product .clearable .autocomplete-box .result-list li.active').trigger("click");
    return;
  }
  return true;
}

export const autoCompleteHsCode = () => {
  $(".product input.form-control").on("keyup", function (e) {
    validate('.product input.form-control', undefined, true);
    if (autoCompleteDropdownKeyUp(e)) {
      if ($(this).val() !== "") {
        autoCompleteapi();
      } else {
        if (window.hsSearch && typeof window.hsSearch.abort === "function") {
          window.hsSearch.abort();
        }
        fillAutocomplete("");
      }
      window.searchData.hs = '';
      delete window.orderInfo;
      setOrderInfoLabel();
    }
    if (checkSearchForm()) {
      setStep(2);
    }
  });

  $("body").mouseup(function (e) {
    let container = $(".section-search .product .clearable .autocomplete-box");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      fillAutocomplete("");
    }
  });

  $("body").on("mouseover", '.section-search .product .clearable .autocomplete-box .result-list li', function () {
    $('.section-search .product .clearable .autocomplete-box .result-list li').removeClass("active");
    $(this).addClass("active");
  });

  $("body").on("click", '.section-search .product .clearable .autocomplete-box .result-list li', function () {
    $('.section-search .product .clearable .autocomplete-box').hide();
    window.searchData.hs = $(this).attr("data-hs");
    window.searchData.uom = $(this).attr("data-uom");
    setUom($(this).attr("data-uom"));
    $('.product input.form-control').val(stripHTML($(this).attr("data-text")));
    fillAutocomplete("");
    clearSearchImage();
    // resetOrderInfo();
    // fetchCustomField();
    checkSearchForm();
    setStep(2);
    // $('.export-country select')[0].selectize.open();
  });
}

export const fetchCustomField = (isShowOrderInfo = true) => {
  if (window.searchData.destination && window.searchData.hs && window.searchData.export) {
    tariffFields({
      destination: window.searchData.destination,
      product: window.searchData.hs,
      origin: window.searchData.export
    }, function (data) {
      window.orderInfo = data;
      // genOrderInfoForm(data);
      checkSearchForm();
      if (checkSearchForm()) {
        if (window.isDetail && !window.isReported) {
          search(false);
        } else {
          if (isShowOrderInfo) {
            focusOrderInfo();
          }
        }
      } else {
        if (isShowOrderInfo) {
          focusOrderInfo();
        }
      }

    }, function () {
      const data = TariffField.fromApiArray([
        {
          "name": "order_value",
          "label": "Order value",
          "hint": "Order value",
          "type": "currency",
          "unit": "$",
          "input_type": "frontend",
          "default_value": null
        }
      ]);
      window.orderInfo = data;
      // genOrderInfoForm(data);
      if (checkSearchForm()) {
        if (window.isDetail || !window.isReported) {
          search(false);
        }
      } else {
        // if (isShowOrderInfo) {
        //   focusOrderInfo();
        // }
      }
    })
  }
}

export const focusOrderInfo = () => {
  $('.search-form .order-info .order-info-label').trigger('click');
  $('#order-info .input-list .form-group:first .input-box .input input').focus();
  $('#order-info .input-list .form-group:first .input-box .input select').focus();
}

export const validateSearch = (showInvalid) => {
  // return validate(".export-country select", undefined, false, showInvalid) && validate(".destination-country select", undefined, false, showInvalid) && validate(".product input.form-control", undefined, false, showInvalid) && $('.search-form .order-info .order-info-label').text();
  // return validate(".destination-country select", undefined, false, showInvalid) && validate(".product input.form-control", undefined, false, showInvalid);
  return validate(".destination-country select", undefined, false, showInvalid);
}

export function search(showInvalid = true, fork = false, isNotSearch = false) {
  if (validateSearch(showInvalid) && (isChangeSearchParam() || fork)) {
    let query = {
      "export": window.searchData.export,
      "destination": window.searchData.destination,
      "hs": window.searchData.hs,
      "currency": window.searchData.currency,
    };
    let product = $(".product input.form-control").val();

    if (product && product !== window.searchData.hs) {
      query.product = product;
      query.hs = undefined;
      window.searchData.hs = undefined;
      window.searchData.parent = undefined;
      window.searchData.product = product;
    } else {
      window.searchData.product = undefined;
    }

    // query = genOrderInfoQuery(query);
    window.searchData.wait = undefined;
    window.searchData.mode = undefined;
    historyPushState(window.location.href.split(/[?#]/)[0] + "?" + queryString.stringify(query));
    keepQuerySetup();
    if (!isNotSearch) {
      // if (!isNotSearch && window.searchData.export && window.searchData.destination && window.searchData.hs) {
      // if (!isNotSearch && window.searchData.destination && window.searchData.hs) {
      if (!isNotSearch && window.searchData.destination) {
        getDataWithHS(window.searchData);
      }
      window.isDetail = true;
      $('.main-page').addClass('search-detail');
    }
  } else {
    $('.destination-country select')[0].selectize.open();
  }
  // if (!window.searchData.hs && $(".product input.form-control").val()) {
  //   $(".product input.form-control").trigger("keyup");
  // }
}

export const getData = (params) => {
  const apiTime = Date.now();
  window.apiTime = apiTime;
  // const exportCountryObj = getCountryDetail(params.export);
  // const destinationCountryObj = getCountryDetail(params.destination);
  // $(".section-overview .country .origin .value span").text(exportCountryObj.name);
  // $(".section-overview .country .destination .value span").text(destinationCountryObj.name);
  // $(".section-requirement .col-export .head-box span").text(exportCountryObj.name);
  // $(".section-requirement .col-import .head-box span").text(destinationCountryObj.name);
  // $(".section-import span.country").text(destinationCountryObj.name);
  // $(".section-market span.country").text(exportCountryObj.name);
  // hsSearch(params.export, params.destination, params.hs, function (result) {
  // classification(params.destination, params.hs || params.product, undefined, undefined, function (result) {

  aiclassify(
    params,
    /** @param {AIClassification} result */
    function (result) {
      cntRetry = 0;
      if (result.hsCode) {
        $('.section-aiclassify').css('display', "none");
        onSuccessClassify(result.commodity, params, apiTime);
      } else {
        $('.section-result').css('display', "none");
        onQuestionClassify(result.question, params);
        onBreadCrumb(result.parent?.path);
      }
    }, function (error) {
      if (cntRetry < 3) {
        cntRetry++;
        getData(params);
      } else {
        // $(".product input.form-control").val(window.searchData.hs).trigger("change");
        delete window.orderInfo;
        window.searchData.hs = '';
        setUom("");
        hideLoading();
        $(".section-noresult").show();
        $(".section-share").hide();

        const errorCode = getOr('', 'error_code')(error);
        if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
          showLimit();
          return;
        }
        $('.section-result').css('display', "none");
      }
    }, apiTime);
}

/**
 * @param {[Classification]} path 
 */
function onBreadCrumb(path = []) {
  let breadcrumb = $(".section-aiclassify .d-breadcrumb");
  let newUrl = changeQueryString("parent", undefined);
  breadcrumb.html(`<li><a ref="nofollow" href="${newUrl}"><span class="breadcrumb-item" title="${window.searchData?.product}">${window.searchData?.product}</span></a></li>`);
  if (path.length) {
    path.forEach(element => {
      newUrl = changeQueryString("parent", element.code);
      breadcrumb.append(`
        <li><a ref="nofollow" href="${newUrl}"><img class="breadcrumb-divider" alt="icon" src="${require("../../assets/images/Arrow_Long_Right.svg")}" /><span class="breadcrumb-item" title="${element.description}">${element.description}</span></a></li>
      `)
    });
    breadcrumb.removeClass("hidden");
  } else {
    breadcrumb.addClass("hidden");
  }
}

/**
 * @param {[Classification]} result 
 */
function onSuccessClassify(result, params, apiTime) {
  if (result.length) {
    if (params.destination && params.wait === undefined) {
      $(".section-overview").css('display', 'block');
    }
    hideLoading();
    $(".section-noresult").hide();
    $(".section-share").show();
    let isShowFullTree = result[0].selectable && result.length === 1;
    loadClassification(result, isShowFullTree);
    let hsCode = result[0]?.hsCode;
    if (params.hs || (result.length === 1)) {
      if (isShowFullTree) {
        $(".section-overview.header h2[tab='commodity']").addClass("hidden");
        setActiveTab(TAB_ID.BROWSE);
      } else {
        if (!params.hs) {
          let newUrl = changeQueryString("hs", hsCode);
          newUrl = changeQueryString("product", undefined, newUrl);
          historyPushState(newUrl, true);
        }
        window.searchData.hs = hsCode;
        $('.search-form .product input').val(hsCode);
        loadTariff(params, apiTime);
      }
    }
  } else {
    window.searchData.hs = '';
    delete window.orderInfo;
    setUom();
    hideLoading();
    $(".section-noresult").show();
    $(".section-share").hide();
    $('.section-result').css('display', "none");
  }
  checkSearchForm();
}

/**
 * @param {Question} question 
 */
function onQuestionClassify(question, params) {
  $('.section-aiclassify h2').text(question?.name);
  let subEl = $(`.section-aiclassify .list-answer`);
  subEl.html("");

  if (question.answer?.length) {
    question.answer.forEach(element => {
      element.render(subEl);
    });
    $('.section-aiclassify').css('display', "block");

    if (params.parent) {
      let newUrl = changeQueryString("parent", params.parent);
      historyPushState(newUrl, true);
    }
    // $('.section-aiclassify .btn-next-aiclassify').off('click');
    // $('.section-aiclassify .btn-next-aiclassify').on('click', function () {
    //   let hsCode = $(".section-aiclassify input[name='question_answer']:checked").val();
    //   if (window.searchData && hsCode) {
    //     window.searchData.parent = hsCode;
    //     getDataWithHS(window.searchData);
    //   }
    // })

    $('.section-aiclassify .list-answer .item-answer .radio input').off('change');
    $('.section-aiclassify .list-answer .item-answer .radio input').on('change', function () {
      let hsCode = $(this).val();
      if (window.searchData && hsCode) {
        window.searchData.parent = hsCode;
        getDataWithHS(window.searchData, true);
      }
    })

    let lstClassify = $('.section-aiclassify .list-answer');
    lstClassify?.length && isOverflowing(lstClassify[0]) ? lstClassify.addClass("overflow") : lstClassify.removeClass("overflow");
  } else {
    $(".section-noresult").show();
    $('.section-aiclassify').css('display', "none");
  }
  hideLoading();
}

export function getDataWithHS(params, isLoadingOverlay) {
  // if (params.export && params.wait === undefined) {
  if (params.destination && params.wait === undefined) {
    showLoading(isLoadingOverlay);
  }
  resetData();
  // if (params.export && params.wait === undefined) {
  if (params.destination && params.wait === undefined) {
    window.isDetail = true;
    $('.main-page').addClass('search-detail');
  }

  if (params.hs || params.product) {
    getHsVersion(params.destination, function (data) {
      window.hsRev = data;
      getData(params);
    }, function (error) {
      $('.go-button .btn').removeAttr("disabled");
      getData(params);
    })
  } else {
    loadClassification([]);
    $(".section-overview.header h2[tab='commodity']").addClass("hidden");
    setActiveTab(TAB_ID.BROWSE);
    $(".section-overview").css("display", "block");
    hideLoading(isLoadingOverlay);
  }
}

export const resetData = () => {
  window.isDetail = false;
  $('.main-page').removeClass('search-detail');
  $('.main-page').removeClass('limit');
  $('.main-page').removeClass('compare');
  window.apiTime = Date.now();
  $(".section-overview, .section-goods, .section-market, .section-import, .section-import-tax, .section-taxes, .section-requirement, .section-market-static, .section-market-ranking, .section-provided, .section-aiclassify").css('display', 'none');
  $(".section-import .row > div").css('display', 'none');
  $(".section-market .row > div").css('display', 'none');
  $(".section-import-tax .row > div").css('display', 'none');
  $(".section-taxes .row > div").css('display', 'none');
  $(".section-requirement .row > div").css('display', 'none');
  $(".section-market-static .opportunity").css('display', 'none');
  $("#detail > div").collapse("hide");
  $("#detail .table .item .data").collapse("hide");
  $("#detail .table .item .data").collapse("hide");
  $(".section-taxes .box .detail").collapse("hide");
  $(".section-share").css('display', 'none');
  $(".section-import-tax").removeAttr("type");
  $(".section-noresult").hide();
}

export const showLoading = (isLoadingOverlay) => {
  // $(".section-overview").removeClass('loading').addClass('loading');
  $(".main-page").addClass(isLoadingOverlay ? "loading-overlay" : "loading");
}

export const hideLoading = () => {
  // $(".section.section-overview").removeClass('loading');
  $(".main-page").removeClass("loading-overlay").removeClass("loading");
}

export function getReport(params, exportCountryObj, destinationCountryObj, apiTime) {
  window.isReported = true;
  // if (window.page !== 'tradeAdvisory') {
  loadTariff(params, apiTime);
  // }

  // TODO: remove all features
  // if (window.page !== 'dutyTaxCalculation') {
  //   $(".section-market, .section-import, .section-requirement, .section-market-static, .section-market-ranking").removeClass('loading').addClass('loading');
  //   getMarketRank(params, exportCountryObj, destinationCountryObj, apiTime);
  //   getStatictic(params, exportCountryObj, destinationCountryObj, apiTime);
  //   getPotential(params, exportCountryObj, destinationCountryObj, apiTime);
  //   getRequirement(params, exportCountryObj, destinationCountryObj, apiTime);
  //   getMap(params, exportCountryObj, destinationCountryObj, apiTime);
  // }
}

export async function getRequirement(params, exportCountryObj, destinationCountryObj, apiTime) {
  const exportRequirement = getExportRequirement(params, exportCountryObj, destinationCountryObj, apiTime);
  const importRequirement = getImportRequirement(params, exportCountryObj, destinationCountryObj, apiTime);
  await importRequirement;
  await exportRequirement;
  loadColor();
  $(".section-requirement").removeClass('loading');
}

export function showLimit() {
  $('.main-page').addClass('limit');
}

export function loadTariff(params, apiTime) {
  $(".section-import-tax.import,.section-import-tax.export").removeClass('loading').addClass('loading');
  $(".section-provided").css("display", "block");
  return getTariff(params, apiTime);
}

export function setUpTariff() {
  $(".section-import-tax .nav-box .item").on("click", function (e) {
    $(".section-import-tax").attr("type", $(this).data("id"));
    if ($(this).data("id") !== "customize") {
      window.apiTime = Date.now();
      loadTariff(window.searchData, window.apiTime);
    }
  });

  $("body").on("change", ".section-import-tax .requirement .content .item input", function (e) {
    window.apiTime = Date.now();
    loadTariff(window.searchData, window.apiTime);
  })

  $(".section-import-tax .nav-box .item").each(function (i, obj) {
    $(this).attr("tfc", Track.genNormalTrack("", "import-tax", $(obj).data("id"), ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
    $(this).attr("tfh", Track.genNormalTrack("", "import-tax", $(obj).data("id"), ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
  });

  setUpTariffEvent();
}

function setActiveTab(tab) {
  isActiveTab = tab;
  $(".section-goods").css('display', 'none');
  $(".section-overview:not(.header)").css('display', 'none');

  $(".section-overview.header h2 .title").removeClass("active");
  $(`.section-overview.header h2[tab='${tab}'] .title`).addClass("active");

  if (isActiveTab === TAB_ID.BROWSE) {
    $(".section-goods").css('display', 'block');
  } else {
    $(".section-overview").css('display', 'block');
  }
}